
(function(){

  function pad(n){
    return n < 10 ? '0' + n : '' + n;
  }

  function formatTime(ms){
    var hours = Math.floor(ms / 3600000);
    var minutes = Math.floor((ms % 3600000) / 60000);
    var seconds = Math.floor((ms % 60000) / 1000);

    return pad(hours) + ':' + pad(minutes) + ':' + pad(seconds);
  }

  function getDubaiStartTime(startDate){
    var parts = startDate.split(/[- :]/);

    var year = parseInt(parts[0], 10);
    var month = parseInt(parts[1], 10) - 1;
    var day = parseInt(parts[2], 10);
    var hour = parseInt(parts[3], 10);
    var minute = parseInt(parts[4], 10);
    var second = parseInt(parts[5] || 0, 10);

    // Asia/Dubai = UTC +4
    return Date.UTC(year, month, day, hour - 4, minute, second);
  }

  function updateCountdown(){
    var nodes = document.getElementsByClassName('countdown');
    var now = Date.now();

    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];

      var defaultValue = node.getAttribute('data-default') || '48:00:00';
      var startDate = node.getAttribute('data-start');

      if (!startDate) {
        node.textContent = defaultValue;
        continue;
      }

      var startTime = getDubaiStartTime(startDate);
      var countdownMs = 48 * 60 * 60 * 1000;
      var endTime = startTime + countdownMs;

      if (now < startTime) {
        node.textContent = defaultValue;
      } else if (now >= startTime && now < endTime) {
        node.textContent = formatTime(endTime - now);
      } else {
        node.textContent = '00:00:00';
      }
    }
  }

  updateCountdown();
  setInterval(updateCountdown, 1000);

})();
